import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

/**
 *  ADMIN › NAPLÓ ÉS ÉRTÉKELÉS › IGAZOLATLAN MULASZTÁS – ÉRTESÍTÉSEK  (backend/mulasztas-ertesites.js)
 *
 *  „Adhassuk meg kinek menjen” (user, 2026-11-05): az automatikus szülői értesítő ki-be kapcsolása, a
 *  kezdőnap (ennél régebbi igazolatlan napról nem szól), a kiskorú tanuló is kapja-e, és a küszöbjelzés /
 *  összesítő címzettjei: osztályfőnök, igazgató, adminok, név szerint felvett munkatársak. Alul a most
 *  érvényes vezetői kör névvel és okkal, hogy látszódjon, kinek megy ténylegesen.
 */
@Component({
  selector: 'app-admin-mulasztas-ertesites',
  templateUrl: './mulasztas-ertesites.component.html',
  styleUrls: ['./mulasztas-ertesites.component.scss'],
})
export class AdminMulasztasErtesitesComponent implements OnInit {
  intezmeny = '';
  betolt = false;
  ment = false;
  b: any = { szulo_ertesito: true, tanulo_is: true, kezdonap: null, osztalyfonok: true, igazgato: true, adminok: true, osszesito: true, szemelyek: [] };
  vezetok: { adid: string; nev: string; ok: string }[] = [];
  allomany: { adid: string; nev: string }[] = [];

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    const si: any = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = String(si?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    this.data.getAllomany(this.intezmeny).subscribe({
      next: (r: any) => {
        this.allomany = (Array.isArray(r) ? r : [])
          .map((a: any) => ({ adid: a.adid, nev: `${a.viselt_vez || ''} ${a.viselt_ker || ''}`.trim() || a.adid }))
          .sort((x, y) => x.nev.localeCompare(y.nev, 'hu'));
      },
      error: () => { this.allomany = []; },
    });
    await this.toltes();
  }

  private atvesz(r: any) {
    this.b = { ...r.beallitas, szemelyek: [...(r.beallitas?.szemelyek || [])] };
    this.vezetok = r.vezetok || [];
  }

  async toltes() {
    if (!this.intezmeny) return;
    this.betolt = true;
    try {
      this.atvesz(await firstValueFrom(this.http.get(`/api/mulasztas-ertesites/beallitas/${this.intezmeny}`)));
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'Nem sikerült betölteni a beállítást.', 'error');
    } finally { this.betolt = false; }
  }

  async mentes() {
    this.ment = true;
    try {
      this.atvesz(await firstValueFrom(this.http.put(`/api/mulasztas-ertesites/beallitas/${this.intezmeny}`, this.b)));
      this.data.sendToast('A beállítás mentve.', 'success');
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A mentés nem sikerült.', 'error');
    } finally { this.ment = false; }
  }

  get kezdonapSzoveg(): string {
    const d = String(this.b.kezdonap || '');
    return /^\d{4}-\d{2}-\d{2}$/.test(d) ? d.replace(/-/g, '. ') + '.' : '';
  }
}
